import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '@/shared/components/Button';
import SimplePanel from '@/shared/components/SimplePanel';
import { useStateService } from '@/shared/services/StateService';
import { canViewWizard } from '../../capacityPlanningAccess';
import messages from '../readinessMessages';
import { getSectionStats } from '../readinessSections';
import { useCapacityPlanningReadiness } from '../useCapacityPlanningReadiness';
import ReadinessDetail from './ReadinessDetail';
import ReadinessOverview from './ReadinessOverview';
import ScheduleSection from './ScheduleSection';
import TemplatesSection from './TemplatesSection';
import TimeTablesSection from './TimeTablesSection';
import UsersSection from './UsersSection';
import '../../capacityPlanning.scss';
import '../capacityPlanningReadiness.scss';
const CapacityPlanningReadiness = () => {
    const intl = useIntl();
    const stateService = useStateService();
    const { data: readiness, isFetching, refetch } = useCapacityPlanningReadiness();
    const [view, setView] = useState(null);
    const openView = (next) => {
        setView(next);
        window.scrollTo(0, 0);
    };
    const buttons = (_jsxs("div", Object.assign({ className: "step-buttons" }, { children: [canViewWizard() && (_jsx(Button, Object.assign({ onClick: () => stateService.gotoState('assignmentAnalysis.capacityPlanningWizard') }, { children: intl.formatMessage(messages.BackToWizard) }))), _jsxs(Button, Object.assign({ btnClassName: "btn-inverse", disabled: isFetching, onClick: () => refetch() }, { children: [isFetching && _jsx("i", { className: "fa fa-spinner fa-spin margin5R" }), intl.formatMessage(messages.CheckAgain)] }))] })));
    const renderSection = (data, section) => {
        switch (section) {
            case 'timeTables':
                return _jsx(TimeTablesSection, { employees: data.employees });
            case 'templates':
                return _jsx(TemplatesSection, { templates: data.templates });
            case 'schedule':
                return (_jsx(ScheduleSection, { issues: data.scheduleIssues, checkedCount: data.scheduleCheckedCount }));
            default:
                return (_jsx(UsersSection, { issues: data.relationIssues, checkedCount: data.relationCheckedCount }));
        }
    };
    const renderReadiness = (data) => {
        const sections = getSectionStats(data);
        const stats = sections.find(section => section.view === view);
        if (!stats)
            return _jsx(ReadinessOverview, { sections: sections, onOpen: openView });
        return (_jsx(ReadinessDetail, Object.assign({ stats: stats, onBack: () => openView(null) }, { children: renderSection(data, stats.view) })));
    };
    return (_jsxs(SimplePanel, Object.assign({ className: "capacity-planning capacity-planning-readiness", title: intl.formatMessage(messages.Title), buttons: buttons }, { children: [!readiness && isFetching && (_jsxs("p", { children: [_jsx("i", { className: "fa fa-spinner fa-spin margin5R" }), intl.formatMessage(messages.Checking)] })), readiness && renderReadiness(readiness)] })));
};
export default CapacityPlanningReadiness;
